module.exports = "/images/analitics-icon.svg?f33eb90a25fadc33a3ab4071e660e06f";